import { render } from "./OrderList.vue?vue&type=template&id=9317c11e&scoped=true&ts=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"

import "./OrderList.vue?vue&type=style&index=0&id=9317c11e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9317c11e"]])

export default __exports__